import TheHomePage from '@/client/pages/home';
import { lazy, type FC, type PropsWithChildren, type ReactNode } from 'react';

const TheErrorPage = lazy(() => import('@/client/pages/error'));
const TheEventPage = lazy(() => import('@/client/pages/event'));
const TheLeaderboard = lazy(() => import('@/client/pages/leaderboard'));
const TheMarketsPage = lazy(() => import('@/client/pages/markets'));
const ThePortfolioPage = lazy(() => import('@/client/pages/portfolio'));
const TheMarketPage = lazy(() => import('@/client/pages/market'));
const ThePDFPage = lazy(() => import('@/client/pages/pdf'));
const TheUserPage = lazy(() => import('@/client/pages/user'));
const TheInviteEarnPage = lazy(() => import('@/client/pages/user/invite-earn'));
const TheNotificationPage = lazy(() => import('@/client/pages/user/notification'));
const TheUserSettingsPage = lazy(() => import('@/client/pages/user/settings'));
const PreviewHome = lazy(() => import('@/client/pages/preview'));
const ClobMarketPage = lazy(() => import('@/client/pages/clob-market'));
const TheLoginCallbackPage = lazy(() => import('@/client/pages/login'));

export type RouteItem = {
  name: string;
  path: string;
  component: FC | JSX.Element;
  fallback?: ReactNode;
  layout?: FC<PropsWithChildren>;
  children?: RouteItem[];
};

// Minimal layout without any providers
const MinimalLayout: FC<PropsWithChildren> = ({ children }) => <>{children}</>;

export const routes: RouteItem[] = [
  // Preview route (Figma style with mock data - no backend dependency)
  {
    path: '/preview',
    name: 'preview',
    component: PreviewHome,
    layout: MinimalLayout,
  },
  // DID OAuth callback (minimal chrome — bounces home on success)
  {
    path: '/login',
    name: 'login',
    component: TheLoginCallbackPage,
    layout: MinimalLayout,
  },
  // Original routes
  {
    path: '/',
    name: 'home',
    component: TheHomePage,
  },
  {
    path: '/markets',
    name: 'markets',
    component: TheMarketsPage,
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: ThePortfolioPage,
  },
  {
    path: '/event/:id',
    name: 'event',
    component: TheEventPage,
  },
  {
    path: '/market/:id',
    name: 'market',
    component: TheMarketPage,
  },
  {
    path: '/clob/:conditionId',
    name: 'clob-market',
    component: ClobMarketPage,
  },
  {
    path: '/user/:id',
    name: 'user',
    component: TheUserPage,
    children: [
      {
        path: '/settings',
        name: 'user-settings',
        component: TheUserSettingsPage,
      },
      {
        path: '/notification',
        name: 'user-notification',
        component: TheNotificationPage,
      },
      {
        path: '/invite-earn',
        name: 'user-invite-earn',
        component: TheInviteEarnPage,
      },
    ],
  },
  {
    path: '/leaderboard',
    name: 'leaderboard',
    component: TheLeaderboard,
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: ThePDFPage,
  },
  {
    path: '*',
    name: 'error',
    component: TheErrorPage,
  },
];
